import {getField, updateField} from 'vuex-map-fields';

export default {
    modules: {
        StoreFileList: {
            namespaced: true,
            state: {
                itemList: [],
                searchTerm: null,
                searchTermFile: null,
                selectedItemList: [],
                editedItem: {name: null, description: null},
                options: {
                    page: 1,
                    itemsPerPage: 20,
                    sortBy: ['id'],
                    sortDesc: [true],
                    multiSort: false,
                    mustSort: true,
                    descending: false,

                },
                totalRecords: 0,
                loading: false,
                deleteLoading: false,
                saveLoading: false,
                addLoading: false,
                previewLink: [null, null],
            },

            actions: {
                async fetchItemList(ctx, storeDocItemId) {
                    ctx.commit('updateLoading', true)
                    const requestParams = {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            'credentials': "same-origin",
                        },
                    };
                    const page = ctx.state.options.page
                    const page_size = ctx.state.options.itemsPerPage
                    let order_by = ctx.state.options.sortBy[0]
                    if (ctx.state.options.sortDesc[0] == true) {
                        order_by = '-' + order_by
                    }
                    let url = "/api/store_file/?page=" + page + "&page_size=" + page_size + "&order_by=" + order_by
                    if (storeDocItemId != null)
                        url += '&store_doc_id=' + storeDocItemId
                    if (ctx.state.searchTerm != null) {
                        url += '&search_term=' + ctx.state.searchTerm
                    }
                    if (ctx.state.searchTermFile != null) {
                        url += '&file_search_term=' + ctx.state.searchTermFile
                    }
                    let res = await fetch(url, requestParams);
                    if (!res.ok) {
                        const result = await res.json()
                        this._vm.$toast.error("Error:" + JSON.stringify(result), {timeout: 5000})
                        ctx.commit('updateLoading', false)
                        return
                    }
                    const resJson = await res.json();
                    const totalRecords = resJson.count
                    const rowList = resJson.results
                    // console.log('rowList', rowList)
                    ctx.commit('updateItemList', rowList)
                    ctx.commit('updateTotalRecords', totalRecords)
                    ctx.commit('updateLoading', false)
                },
                async fetchItem(ctx, itemId) {
                    const requestParams = {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            'credentials': "same-origin",
                        },
                    };
                    let url = "/api/store_file/" + itemId + "/"
                    let res = await fetch(url, requestParams);
                    if (!res.ok) {
                        const result = await res.json()
                        this._vm.$toast.error("Error:" + JSON.stringify(result), {timeout: 5000})
                        ctx.commit('updateLoading', false)
                        return
                    }
                    const item = await res.json();
                    ctx.commit('updateItem', item)
                },
                async fetchDeleteItem(ctx, item) {
                    ctx.commit('updateDeleteLoading', true)
                    let csrfToken = this._vm.$cookies.get('csrftoken')
                    const requestParams = {
                        method: "DELETE",
                        headers: {
                            "Content-Type": "application/json",
                            'credentials': "same-origin",
                            'X-CSRFToken': csrfToken,
                        },
                    };
                    const res = await fetch("/api/store_file/" + item.id + '/', requestParams);
                    if (!res.ok) {
                        this.$root.$store._vm.$toast.error("Error:" + JSON.stringify(res), {timeout: 5000})
                        ctx.commit('updateDeleteLoading', false)
                        return
                    }
                    const itemList = ctx.state.itemList.filter(row => row.id != item.id)
                    ctx.commit('updateItemList', itemList)
                    ctx.commit('updateTotalRecords', this.getTotalRecords - 1)
                    ctx.commit('updateDeleteLoading', false)
                },
                async fetchSaveItem(ctx, item) {
                    // console.log('fetchSaveItem')
                    // console.log(item)
                    ctx.commit('updateSaveLoading', true)
                    let csrfToken = this._vm.$cookies.get('csrftoken')
                    const requestParams = {
                        method: "PATCH",
                        headers: {
                            "Content-Type": "application/json",
                            'credentials': "same-origin",
                            'X-CSRFToken': csrfToken,
                        },
                        body: JSON.stringify({
                            'name': item.name,
                            'description': item.description,
                        })
                    };
                    const res = await fetch("/api/store_file/" + item.id + "/", requestParams);
                    if (!res.ok) {
                        const result = await res.json()
                        this._vm.$toast.error("Error:" + JSON.stringify(result), {timeout: 5000})
                        ctx.commit('updateSaveLoading', false)
                    }
                    let rowListEdited = []
                    const result = await res.json()
                    for (let rowListItem of ctx.state.rowList) {
                        if (rowListItem.id === item.id)
                            rowListEdited.push(result)
                        else
                            rowListEdited.push(rowListItem)
                    }
                    ctx.commit('updateItemList', rowListEdited)
                    ctx.commit('updateSaveLoading', false)
                },
                async fetchNewFileItem(ctx, item) {
                    console.log('fetchNewFileItem', item)
                    ctx.commit('updateLoading', true)
                    let csrfToken = this._vm.$cookies.get('csrftoken')
                    let data = new FormData()
                    if (item.file !== null)
                        data.append('file', item.file)
                    if (item.store_doc !== null) {
                        if (typeof item.store_doc === "string") {
                            data.append('store_doc', parseInt(item.store_doc))
                        }
                        else {
                            data.append('store_doc', item.store_doc)
                        }
                    }
                    data.append('title', item.title)
                    data.append('source_type', 'Manual')
                    // if (!!item.description)
                    //     data.append('description', item.description)
                    const requestParams = {
                        method: "POST",
                        headers: {
                            'credentials': "same-origin",
                            'X-CSRFToken': csrfToken,
                        },
                        body: data,
                    };
                    let response = await fetch("/api/store_file/", requestParams)
                    if (!response.ok) {
                        console.log(response)
                        const result = await response.json()
                        console.log(result)
                        this._vm.$toast.error("Error:" + JSON.stringify(result), {timeout: 5000})
                        ctx.commit('updateLoading', false)
                        return
                    }
                    let result = await response.json()
                    let itemList = ctx.state.itemList
                    itemList.unshift(result)
                    ctx.commit('updateItemList', itemList)
                    ctx.commit('updateLoading', false)
                },
                async addNewItem(ctx, item) {
                    let itemList = ctx.state.itemList
                    itemList.unshift(item)
                    ctx.commit('updateItemList', itemList)
                    ctx.commit('updateTotalRecords', ctx.state.totalRecords + 1)
                },
            },

            mutations: {
                updateField,
                updateItemList(state, rowList) {
                    state.itemList = rowList
                },
                updateItem(state, item) {
                    state.editedItem = item
                },
                updateTotalRecords(state, totalRecords) {
                    state.totalRecords = totalRecords
                },
                updateLoading(state, loading) {
                    state.loading = loading
                },
                updateDeleteLoading(state, deleteLoading) {
                    state.deleteLoading = deleteLoading
                },
                updateSaveLoading(state, saveLoading) {
                    state.saveLoading = saveLoading
                },
                updateAddLoading(state, addLoading) {
                    state.addLoading = addLoading
                },
                updateSearchTerm(state, searchTerm) {
                    state.searchTerm = searchTerm
                },
                updateSearchTermFile(state, searchTermFile) {
                    state.searchTermFile = searchTermFile
                }
            },

            getters: {
                getField,
                getRowList(state) {
                    return state.itemList
                },
                getTotalRecords(state) {
                    return state.totalRecords
                },
            }
        }
    }
}